// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper_1KYi6","content":"Page_content_33tXM"};